import {
  createLeaveApi,
  getAllLeavesApi,
  approveOrRejectLeaveApi,
  updateLeaveApi,
  deleteLeaveApi,
   getLeaveByIdApi,
} from "../../api/leave";
import { toast } from "react-toastify";
import { FAILURE, LEAVE_ACTION_TYPES, SUCCESS } from "../utilities";

export const getLeaveById = (leaveId) => async (dispatch, getState) => {
  console.log("getLeaveById ACTION started.");
  dispatch({ type: LEAVE_ACTION_TYPES.GET_LEAVE_DETAILS_REQUEST });
  const token = getState().user?.user?.token;
  if (!token) {
    const message = "Authentication error: Token not found.";
    dispatch({ type: LEAVE_ACTION_TYPES.GET_LEAVE_DETAILS_FAILURE, payload: message });
    return Promise.reject(new Error(message));
  }

  try {
    console.log("Calling getLeaveByIdApi...");
    const { data } = await getLeaveByIdApi(leaveId, token);
    console.log("API call SUCCEEDED. Data received:", data);
    dispatch({
      type: LEAVE_ACTION_TYPES.GET_LEAVE_DETAILS_SUCCESS,
      payload: data,
    });
    return Promise.resolve(data);
  } catch (error) {
    console.error("API call FAILED. Error:", error.response || error);
    const message = error.response?.data?.message || error.message || "Failed to fetch leave details";
    dispatch({
      type: LEAVE_ACTION_TYPES.GET_LEAVE_DETAILS_FAILURE,
      payload: message,
    });
    return Promise.reject(error);
  }
};
export const createLeaveRequest =
  (leaveData, token, moveToNext, failure) => async (dispatch, getState) => {
    dispatch({ type: LEAVE_ACTION_TYPES.CREATE_LEAVE_REQUEST });
    createLeaveApi(leaveData, token).then(
      (response) => {
        if (response.data.succeeded) {
          dispatch(
            SUCCESS(LEAVE_ACTION_TYPES.CREATE_LEAVE_SUCCESS, response.data.data)
          );
          if (moveToNext) moveToNext();
        } else {
          dispatch(
            FAILURE(
              LEAVE_ACTION_TYPES.CREATE_LEAVE_FAILURE,
              response.data.message
            )
          );
          if (failure) {
            failure(response.data.message);
          }
        }
      },
      (error) => {
        dispatch(
          FAILURE(LEAVE_ACTION_TYPES.CREATE_LEAVE_FAILURE, error.message)
        );
        if (failure) {
          failure(error?.response?.data?.message || "Failed to Update");
        }
      }
    );
    // const token = getState().user?.user?.token;
    // if (!token) {
    //   const message = "Authentication error: Token not found.";
    //   dispatch({
    //     type: LEAVE_ACTION_TYPES.CREATE_LEAVE_FAILURE,
    //     payload: message,
    //   });
    //   return Promise.reject(new Error(message));
    // }

    // try {
    //   const { data } = await createLeaveApi(leaveData, token);

    //   if (data.succeeded) {
    //     dispatch({
    //       type: LEAVE_ACTION_TYPES.CREATE_LEAVE_SUCCESS,
    //       payload: data.data,
    //     });
    //     if (navigate) navigate("/all-requests");
    //     return Promise.resolve(data);
    //   } else {
    //     throw new Error(data.message);
    //   }
    // } catch (error) {
    //   const message = error.response?.data?.message || error.message;
    //   dispatch({
    //     type: LEAVE_ACTION_TYPES.CREATE_LEAVE_FAILURE,
    //     payload: message,
    //   });
    //   return Promise.reject(error);
    // }
  };

export const getAllLeaves = (filters) => async (dispatch, getState) => {
  dispatch({ type: LEAVE_ACTION_TYPES.GET_ALL_LEAVES_REQUEST });
  const token = getState().user?.user?.token;
  if (!token) {
    return;
  }
  try {
    const { data } = await getAllLeavesApi(filters, token);
    if (data && data.leaves) {
      dispatch({
        type: LEAVE_ACTION_TYPES.GET_ALL_LEAVES_SUCCESS,
        payload: data,
      });
    } else {
      throw new Error("Invalid data format");
    }
  } catch (error) {
    const message = error.response?.data?.message || error.message;
    dispatch({
      type: LEAVE_ACTION_TYPES.GET_ALL_LEAVES_FAILURE,
      payload: message,
    });
  }
};

export const approveOrRejectLeave =
  (leaveId, approved) => async (dispatch, getState) => {
    dispatch({ type: LEAVE_ACTION_TYPES.UPDATE_LEAVE_REQUEST });
    const token = getState().user?.user?.token;
    if (!token) {
      return Promise.reject("No Token Found");
    }

    try {
      const { data } = await approveOrRejectLeaveApi(leaveId, approved, token);
      if (data && data.leave) {
        dispatch({
          type: LEAVE_ACTION_TYPES.UPDATE_LEAVE_SUCCESS,
          payload: data.leave,
        });
        return Promise.resolve(data);
      } else {
        throw new Error(data.message || "Invalid response from server");
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      dispatch({
        type: LEAVE_ACTION_TYPES.UPDATE_LEAVE_FAILURE,
        payload: message,
      });
      return Promise.reject(error);
    }
  };

export const updateLeaveRequest =
  (leaveId, leaveData, token, moveToNext, failure) => async (dispatch) => {


     dispatch({ type: LEAVE_ACTION_TYPES.UPDATE_LEAVE_REQUEST });
    updateLeaveApi(leaveId,leaveData, token).then(
      (response) => {
        if (response.data.succeeded) {
          dispatch(
            SUCCESS(LEAVE_ACTION_TYPES.UPDATE_LEAVE_SUCCESS, response.data.data)
          );
          if (moveToNext) moveToNext();
        } else {
          dispatch(
            FAILURE(
              LEAVE_ACTION_TYPES.UPDATE_LEAVE_FAILURE,
              response.data.message
            )
          );
          if (failure) {
            failure(response.data.message);
          }
        }
      },
      (error) => {
        dispatch(
          FAILURE(LEAVE_ACTION_TYPES.UPDATE_LEAVE_FAILURE, error.message)
        );
        if (failure) {
          failure(error?.response?.data?.message || "Failed to Update");
        }
      }
    );

  };

export const deleteLeaveRequest = (leaveId) => async (dispatch, getState) => {
  dispatch({ type: LEAVE_ACTION_TYPES.DELETE_LEAVE_REQUEST });
  const token = getState().user?.user?.token;
  if (!token) {
    return Promise.reject("No Token Found");
  }

  try {
    const { data } = await deleteLeaveApi(leaveId, token);
    if (data && data.succeeded) {
      dispatch({
        type: LEAVE_ACTION_TYPES.DELETE_LEAVE_SUCCESS,
        payload: leaveId,
      });
      return Promise.resolve(data);
    } else {
      throw new Error(data.message || "Could not delete the request.");
    }
  } catch (error) {
    const message = error.response?.data?.message || error.message;
    dispatch({
      type: LEAVE_ACTION_TYPES.DELETE_LEAVE_FAILURE,
      payload: message,
    });
    return Promise.reject(error);
  }
};
